import FetchApi from "../Helpers/FetchApi";
import "./form.css";
import { Link } from "react-router-dom";
import { useState } from "react";

export default function Form() {
    const [boton, setBoton] = useState(true);
    const [mujer, setMujer] = useState(false);
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        about: "",
        coverphoto: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        console.log(formData);
        e.preventDefault();
    };

    return (
        <>
            <h1>Are you feeling lucky today?</h1>

            {boton ? (
                <div className='form'>
                    <div>
                        <div className='md:grid md:grid-cols-3 md:gap-6'>
                            <div className='md:col-span-1'>
                                <div className='px-4 sm:px-0'>
                                    <h3 className='text-lg font-medium leading-6 text-gray-900'>
                                        Profile
                                    </h3>
                                    <p className='mt-1 text-sm text-gray-600'>
                                        This information will be used to find
                                        your perfect match and will be erased
                                        after the match is made ❤.
                                    </p>
                                </div>
                            </div>
                            <div className='mt-5 md:mt-0 md:col-span-2'>
                                <form action='#'>
                                    <div className='shadow sm:rounded-md sm:overflow-hidden'>
                                        <div className='px-4 py-5 bg-white space-y-6 sm:p-6'>
                                            <div className='grid grid-cols-3 gap-6'>
                                                <div className='col-span-3 sm:col-span-2'>
                                                    <label
                                                        htmlFor='company-website'
                                                        className='block text-sm font-medium text-gray-700'>
                                                        Your Name
                                                    </label>
                                                    <div className='mt-1 flex rounded-md shadow-sm'>
                                                        <span className='inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm'>
                                                            First Name
                                                        </span>
                                                        <input
                                                            type='text'
                                                            name='firstName'
                                                            id='firstName'
                                                            className='focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-r-md sm:text-sm border-gray-300'
                                                            placeholder='George Smiley'
                                                            value={
                                                                formData.firstName
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                <label
                                                    htmlFor='about'
                                                    className='block text-sm font-medium text-gray-700'>
                                                    About
                                                </label>
                                                <div className='mt-1'>
                                                    <input
                                                        name='about'
                                                        id='about'
                                                        rows={3}
                                                        className='shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md'
                                                        placeholder="I'm a single father and I'm looking for a loving home."
                                                        value={formData.about}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <p className='mt-2 text-sm text-gray-500'>
                                                    Brief description for your
                                                    profile.
                                                </p>
                                            </div>

                                            <div>
                                                <label className='block text-sm font-medium text-gray-700'>
                                                    Cover photo
                                                </label>
                                                <div className='mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md'>
                                                    <div className='space-y-1 text-center'>
                                                        <svg
                                                            className='mx-auto h-12 w-12 text-gray-400'
                                                            stroke='currentColor'
                                                            fill='none'
                                                            viewBox='0 0 48 48'
                                                            aria-hidden='true'>
                                                            <path
                                                                d='M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02'
                                                                strokeWidth={2}
                                                                strokeLinecap='round'
                                                                strokeLinejoin='round'
                                                            />
                                                        </svg>
                                                        <div className='flex text-sm text-gray-600'>
                                                            <label
                                                                htmlFor='file-upload'
                                                                className='relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500'>
                                                                <span>
                                                                    Upload a
                                                                    file
                                                                </span>
                                                                <input
                                                                    type='file'
                                                                    name='coverphoto'
                                                                    id='coverphoto'
                                                                    className='focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-r-md sm:text-sm border-gray-300'
                                                                    value={
                                                                        formData.coverphoto
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                />
                                                            </label>
                                                            <p className='pl-1'>
                                                                or drag and drop
                                                            </p>
                                                        </div>
                                                        <p className='text-xs text-gray-500'>
                                                            PNG, JPG, GIF up to
                                                            10MB
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className='hidden sm:block' aria-hidden='true'>
                        <div className='py-5'>
                            <div className='border-t border-gray-200' />
                        </div>
                    </div>

                    <div className='hidden sm:block' aria-hidden='true'>
                        <div className='py-5'>
                            <div className='border-t border-gray-200' />
                        </div>
                    </div>

                    <div className='mt-10 sm:mt-0'>
                        <div className='md:grid md:grid-cols-3 md:gap-6'>
                            <div className='md:col-span-1'>
                                <div className='px-4 sm:px-0'>
                                    <h3 className='text-lg font-medium leading-6 text-gray-900'>
                                        Notifications
                                    </h3>
                                    <p className='mt-1 text-sm text-gray-600'>
                                        Decide which communications you'd like
                                        to receive and how.
                                    </p>
                                </div>
                            </div>
                            <div className='mt-5 md:mt-0 md:col-span-2'>
                                <form action='#'>
                                    <div className='shadow overflow-hidden sm:rounded-md'>
                                        <div className='px-4 py-5 bg-white space-y-6 sm:p-6'>
                                            <fieldset>
                                                <legend className='sr-only'>
                                                    By Email
                                                </legend>
                                                <div
                                                    className='text-base font-medium text-gray-900'
                                                    aria-hidden='true'>
                                                    By Email
                                                </div>
                                                <div className='mt-4 space-y-4'>
                                                    <div className='flex items-start'>
                                                        <div className='flex items-center h-5'>
                                                            <input
                                                                id='comments'
                                                                name='comments'
                                                                type='checkbox'
                                                                className='focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded'
                                                            />
                                                        </div>
                                                        <div className='ml-3 text-sm'>
                                                            <label
                                                                onChange={(e) =>
                                                                    setMujer(
                                                                        !mujer
                                                                    )
                                                                }
                                                                htmlFor='comments'
                                                                className='font-medium text-gray-700'>
                                                                Comments
                                                            </label>
                                                            <p className='text-gray-500'>
                                                                Get notified
                                                                when someones
                                                                comments on your
                                                                profile.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className='flex items-start'>
                                                        <div className='flex items-center h-5'>
                                                            <input
                                                                id='candidates'
                                                                name='candidates'
                                                                type='checkbox'
                                                                className='focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded'
                                                            />
                                                        </div>
                                                        <div className='ml-3 text-sm'>
                                                            <label
                                                                htmlFor='candidates'
                                                                className='font-medium text-gray-700'>
                                                                Matches
                                                            </label>
                                                            <p className='text-gray-500'>
                                                                Get notified
                                                                when a match
                                                                wants to meet
                                                                you.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className='flex items-start'>
                                                        <div className='flex items-center h-5'>
                                                            <input
                                                                id='offers'
                                                                name='offers'
                                                                type='checkbox'
                                                                className='focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded'
                                                            />
                                                        </div>
                                                        <div className='ml-3 text-sm'>
                                                            <label
                                                                htmlFor='offers'
                                                                className='font-medium text-gray-700'>
                                                                Offers
                                                            </label>
                                                            <p className='text-gray-500'>
                                                                Get notified
                                                                when a Match
                                                                accepts or
                                                                rejects an
                                                                offer.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset>
                                                <legend className='contents text-base font-medium text-gray-900'>
                                                    Push Notifications
                                                </legend>
                                                <p className='text-sm text-gray-500'>
                                                    These are delivered via SMS
                                                    to your mobile phone.
                                                </p>
                                                <div className='mt-4 space-y-4'>
                                                    <div className='flex items-center'>
                                                        <input
                                                            id='push-everything'
                                                            name='push-notifications'
                                                            type='radio'
                                                            className='focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300'
                                                        />
                                                        <label
                                                            htmlFor='push-everything'
                                                            className='ml-3 block text-sm font-medium text-gray-700'>
                                                            Everything
                                                        </label>
                                                    </div>
                                                    <div className='flex items-center'>
                                                        <input
                                                            id='push-email'
                                                            name='push-notifications'
                                                            type='radio'
                                                            className='focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300'
                                                        />
                                                        <label
                                                            htmlFor='push-email'
                                                            className='ml-3 block text-sm font-medium text-gray-700'>
                                                            Same as email
                                                        </label>
                                                    </div>
                                                    <div className='flex items-center'>
                                                        <input
                                                            id='push-nothing'
                                                            name='push-notifications'
                                                            type='radio'
                                                            className='focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300'
                                                        />
                                                        <label
                                                            htmlFor='push-nothing'
                                                            className='ml-3 block text-sm font-medium text-gray-700'>
                                                            No push
                                                            notifications
                                                        </label>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>

                                        <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                                            <button
                                                onClick={() => setBoton(false)}
                                                className='inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <h1>
                        <strong>OH MY GOD !!!</strong>
                    </h1>
                    <FetchApi />{" "}
                </>
            )}
        </>
    );
}
